// extracted by mini-css-extract-plugin
export default {"phoneWrapper":"ZKzR8","viewSecondary":"qPb1H","viewPrimary":"OA1GV","sizeS":"HXKpd","phone":"ddogL","sizeM":"IgoTC"};